import axios from "axios";

const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL;
const { host, hostname, origin } = window.location;
// Custom domains proxy /api to the backend, so call it same-origin there to avoid cross-origin blocking.
const useSameOrigin = new URL(ENV_BACKEND).host !== host && !["localhost", "127.0.0.1"].includes(hostname);
export const API = `${useSameOrigin ? origin : ENV_BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !(cfg.url || "").includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
        await refreshing;
        return api(cfg);
      } catch {
        if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
          window.location.href = "/admin/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : "";
        return e && typeof e.msg === "string" ? `${field ? field + ": " : ""}${e.msg}` : JSON.stringify(e);
      })
      .join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (v) => "₹" + Math.round(Number(v) || 0).toLocaleString("en-IN");

export const waPhone = (phone) => {
  const d = (phone || "").replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};

export const waLink = (phone, text) => `https://wa.me/${waPhone(phone)}?text=${encodeURIComponent(text || "")}`;

export const fmtDate = (v) => {
  if (!v) return "-";
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  return isNaN(d) ? v : d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const todayISO = () => new Date().toISOString().split("T")[0];

export async function downloadPdf(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
